import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import { PropTypes } from 'prop-types';
import CustomIcon from '../../../common/CustomIcon';
import StudentGrade from './StudentGrade';
import * as taskActions from '../../../../actions/taskActions';
import * as drawerActions from '../../../../actions/drawerActions';
import * as bookActions from '../../../../actions/bookActions';
import * as assignmentsDrawerActions from '../../../../actions/assignmentsDrawerActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import ContentTaskContainer from '../ContentTaskContainer';
import StudentBox from '../StudentBox';
import PanelsBottomRowButton from '../../../common/PanelsBottomRowButton';
import * as userApi from '../../../../services/api/userApi';
import { ROLE } from '../../../../const';
import FileEvaluationBox from '../FileEvaluationBox';
import * as taskService from '../../../../services/domain/taskService';
import { getStudentAttemptData } from '../../../../types/task';
import { getAsset } from '../../../../services/assets/assetsService';
import FirstEvaluationContainer from '../FirstEvaluationContainer';

class InstructorTaskPanel extends Component {
  state = {
    uploadingFile: false,
    selectedGrade: undefined,
    comment: undefined,
    isEditMode: false,
    evaluationFiles: [],
    toCompareEvaluationFiles: [],
    commentMessageText: undefined,
    isEvaluated: false,
    repeatTask: false
  };

  componentDidMount() {
    const { task, evaluatedStudent, taskActions, bookActions, classroom } = this.props;
    const studentGrade = getStudentAttemptData(task, evaluatedStudent._id);
    const responses = studentGrade.responses.filter(res => res.data && res.data.commentMessageText);
    taskActions.setTaskContentsNotFound(false);
    taskActions.getSelectedTaskWithResults(task.id, evaluatedStudent);
    bookActions.getBookInfo(classroom.id, task.bookId);

    if (studentGrade) {
      const evaluation =
        studentGrade.responses &&
        studentGrade.responses.length &&
        studentGrade.responses[studentGrade.responses.length - 1].evaluation;
      if (evaluation && evaluation.attachments && evaluation.attachments.length) {
        const getAssetPromises = evaluation.attachments.map(uuid => getAsset(uuid, this.props.customerId));
        Promise.allSettled(getAssetPromises).then(res => {
          const okResponses = res.filter(r => r.status !== 'rejected');

          const fetchedFiles = okResponses.map(r => r.value.data);
          this.setState({
            toCompareEvaluationFiles: fetchedFiles
          });
        });
      }
      this.setState({
        selectedGrade: evaluation && evaluation.grade ? evaluation.grade : undefined,
        hoverGrade: undefined,
        isEditMode: typeof (evaluation ? evaluation.grade : undefined) !== 'number',
        commentMessageText: responses.length ? responses[responses.length - 1].data.commentMessageText : '',
        isEvaluated: Boolean(evaluation)
      });
    }
  }

  onInputComment = event => {
    this.setState({
      comment: event.target.value
    });
  };

  getTasks = async newSelectedTask => {
    const { classroom, taskActions, evaluatedStudent } = this.props;

    taskActions.getClassroomTasksWithResults(classroom.id);
    await taskActions.updateSelectedTask(classroom.id, newSelectedTask.id, evaluatedStudent);
  };

  onGradeClick = gradeValue => {
    const { selectedGrade } = this.state;
    this.setState({
      selectedGrade: selectedGrade === gradeValue ? undefined : gradeValue
    });
  };

  closePanel = () => {
    const { drawerActions } = this.props;
    drawerActions.closeDrawerAndRemoveContent();
  };

  getStudentGroup = (groupedStudents, studentId) => {
    for (let group in groupedStudents) {
      if (groupedStudents[group].some(student => student._id === studentId)) {
        return group;
      }
    }
    return null;
  };

  onSubmitButtonClick = async repeatTask => {
    const { evaluatedStudent, task } = this.props;
    const groupedStudents = taskService.setStudentsInGroups(task.users, task, task.resultSummary);
    const studentGroup = this.getStudentGroup(groupedStudents, evaluatedStudent._id);
    const studentTaskGroupId =
      studentGroup && studentGroup.includes('group') ? studentGroup.replace('group', '') : null;

    if (_.isEmpty(this.state.comment)) {
      this.setState({ comment: undefined });
    }

    const evaluation = {
      grade: this.state.selectedGrade,
      comment: this.state.comment,
      canStudentRepeat: repeatTask
    };

    if (studentTaskGroupId && studentTaskGroupId !== 'pending') {
      evaluation.taskGroup = Number(studentTaskGroupId);
    }

    const attempt = getStudentAttemptData(task, evaluatedStudent._id);
    const isUpdate = Boolean(attempt.evaluation);
    try {
      if (this.state.evaluationFiles && this.state.evaluationFiles.length) {
        // Si es update hay que traer los q hay en be, comparar y borrar los q no esten, crear un objeto con los q tienen q qedar y llamar al submit
        // El send file hay que hacerlo con los que son nuevos
        const evaluationFiles = this.state.evaluationFiles;
        const toCompareEvaluationFiles = this.state.toCompareEvaluationFiles;
        let finalUuids = [...toCompareEvaluationFiles];
        let toCreate;
        let toDelete;

        if (isUpdate) {
          // ! Parte 1: Gestionar eliminados
          // Obtenemos los uuids de los ficheros en state
          const existingUuids = evaluationFiles.map(eva => eva.uuid).filter(e => Boolean(e));
          // Creamos toDelete con aquellos uuids que estaban como evaluation pero se borraran
          toDelete = toCompareEvaluationFiles.filter(old => existingUuids.indexOf(old.uuid) < 0);
          // Filtramos finalUuids para eliminar esos que se borraron
          const filteredFinalUuids = finalUuids
            .map(e => e.uuid)
            .filter(final => !toDelete.map(e => e.uuid).includes(final));
          // ! Parte 2: Gestionar añadidos
          // Hay que crear los assets nuevos y añadirlos a finalUuids (estan en evaluationFiles y no en toCompare, son de tipo File)
          toCreate = evaluationFiles.filter(old => toCompareEvaluationFiles.map(e => e.uuid).indexOf(old.uuid) < 0);
          const newFiles = await this.sendFile(toCreate);
          // Añadirlos a finalUuids cuando vuelvan de backoffice
          finalUuids = [...filteredFinalUuids, ...newFiles];
          // ! Final: Hacer la peticion a be con finalUuids
        } else {
          finalUuids = await this.sendFile(this.state.evaluationFiles);
        }
        if (
          (!isUpdate && finalUuids && finalUuids.length) ||
          (isUpdate && ((toCreate && toCreate.length) || (toDelete && toDelete.length)))
        ) {
          evaluation.attachments = finalUuids;
          this.submitEvaluation(evaluation);
        } else {
          this.setState({ uploadingFile: false });
        }
      } else {
        if (this.state.toCompareEvaluationFiles && this.state.toCompareEvaluationFiles.length) {
          const filterUuids = this.state.toCompareEvaluationFiles.map(objeto => objeto.uuid);
          evaluation.attachments = filterUuids;
        }
        this.submitEvaluation(evaluation);
      }
    } catch (err) {
      this.setState({ uploadingFile: false });
    }
  };

  submitEvaluation = async evaluation => {
    const { classroom, evaluatedStudent, task, assignmentsDrawerActions, taskActions } = this.props;
    if (!_.isNil(this.state.selectedGrade)) {
      this.setState({ isEditMode: false, selectedGrade: evaluation.grade });
      taskActions.setEvaluatedAssignmentComments(evaluatedStudent._id);
      const attempt = getStudentAttemptData(task, evaluatedStudent._id);
      const onConflict = err => {
        if (err?.response?.status === 409) {
          assignmentsDrawerActions.setEvaluatedStudentAndOpen(evaluatedStudent);
        }
      };
      if (attempt.evaluation) {
        await userApi.updateEvaluation(classroom.id, evaluatedStudent._id, task.id, evaluation).catch(onConflict);
      } else {
        await userApi.createEvaluation(classroom.id, evaluatedStudent._id, task.id, evaluation).catch(onConflict);
      }
      await this.getTasks(task);
      assignmentsDrawerActions.removeEvaluatedStudentAndOpenStudentsAssignmentPanel();
    }
  };

  sendFile = files => {
    const { assignmentsDrawerActions, customer, classroom } = this.props;
    this.setState({ uploadingFile: true });
    const context = { customerId: customer.id, classroomId: classroom.id };
    return assignmentsDrawerActions.submitFreeAssignmentEvaluation(files, context);
  };

  toggleEditMode = () => {
    const { task, evaluatedStudent } = this.props;
    const attempt = getStudentAttemptData(task, evaluatedStudent._id);
    const lastResponse = attempt.responses[attempt.responses.length - 1];
    const evaluation = lastResponse?.evaluation;
    this.setState({
      isEditMode: true,
      comment: evaluation?.comment || ''
    });
  };

  renderHeader = () => {
    const { task } = this.props;

    if (task) {
      return (
        <div className="header header-assignments">
          <div className="title-assignments">
            <div className="close">
              <CustomIcon name="office-monthly-calendar" size={24} />
            </div>
            <span className="assignment-name">{task.name}</span>
          </div>
          <span className="assignment-due-date">
            {I18n.t('panels.assignment.dueDate')} {dayjs(task.dueDate).format('DD/MM/YYYY HH:mm')}
          </span>
        </div>
      );
    }
  };

  onChangeFile(newFiles, prevFiles) {
    this.setState(
      prevState => ({
        evaluationFiles: newFiles
      }),
      () => {
        if (this.state.toCompareEvaluationFiles.length === 0) {
          this.setState(prevState => ({
            toCompareEvaluationFiles: prevFiles || prevState.toCompareEvaluationFiles
          }));
        }
      }
    );
  }

  shouldRenderAttachments = () => {
    const { task, evaluatedStudent } = this.props;
    const { isEditMode } = this.state;
    const attempt = getStudentAttemptData(task, evaluatedStudent._id);
    const hasAttachments = attempt.evaluation && attempt.evaluation.attachments;
    return hasAttachments || isEditMode;
  };

  render() {
    const { evaluatedStudent, task, avatarsImages, emojis, role, participants } = this.props;
    const { selectedGrade, comment, isEditMode, uploadingFile, commentMessageText } = this.state;
    const studentResults = getStudentAttemptData(task, evaluatedStudent._id);
    const hideRow = !isEditMode || selectedGrade === null || selectedGrade === undefined;
    const disableButtons = hideRow || uploadingFile;
    const isExpiredResponse =
      studentResults.responses[0] &&
      dayjs(task.dueDate).isBefore(dayjs(studentResults.responses[0].date));
    const taskStudents = taskService.getStudentsForTask(task, participants);
    const disableRemakeButton = Boolean(
      studentResults.responses.length > 1 || task.activities?.length
    );
    const multipleStudentResponses = studentResults.responses.length > 1;
    const secondTryEvaluated = multipleStudentResponses && Boolean(studentResults.responses[1].evaluation);
    return (
      <div className="task-panel">
        <div>
          {this.renderHeader()}

          <StudentBox
            task={task}
            taskStudents={taskStudents}
            avatarsImages={avatarsImages}
            evaluatedStudent={evaluatedStudent}
            isExpiredResponse={isExpiredResponse}
          />

          <StudentGrade
            task={task}
            emojis={emojis}
            isTeacher={true}
            comment={comment}
            isEditMode={isEditMode}
            taskActions={taskActions}
            selectedGrade={selectedGrade}
            studentResults={studentResults}
            onGradeClick={this.onGradeClick}
            evaluatedStudent={evaluatedStudent}
            toggleEditMode={this.toggleEditMode}
            onInputComment={this.onInputComment}
            uploadingFile={uploadingFile}
            onChangeFile={index => this.onChangeFile(index)}
            secondTryEvaluated={secondTryEvaluated}
          />
          {this.shouldRenderAttachments() && !uploadingFile && (
            <FileEvaluationBox
              task={task}
              student={evaluatedStudent}
              uploadingFile={uploadingFile}
              onChangeFile={(newFiles, prevFiles) => this.onChangeFile(newFiles, prevFiles)}
              canChange={isEditMode}
              isEvaluated={this.state.isEvaluated}
              isInstructor={true}
            />
          )}
          {uploadingFile && (
            <div
              style={{
                position: 'relative',
                textAlign: 'center',
                padding: '2em'
              }}
              key={'loader'}
            >
              <CircularProgress style={{ display: 'inlineBlock' }}></CircularProgress>
            </div>
          )}
          <ContentTaskContainer
            user={evaluatedStudent}
            task={task}
            isTeacher={true}
            deliveredFile={this.getDeliveredFileInfo}
            deleteResponseFile={this.deleteResponseFile}
            uploadingFile={uploadingFile}
            commentMessageText={commentMessageText}
          />
          {multipleStudentResponses && (
            <FirstEvaluationContainer task={task} user={evaluatedStudent} customer={this.props.customer} />
          )}
        </div>
        {role === ROLE.INSTRUCTOR && (
          <PanelsBottomRowButton
            hideRow={hideRow || disableButtons}
            disableButtons={disableButtons}
            showCancelButton={false}
            primaryButtonText={'panels.assignment.sendGrade'}
            secondaryButtonText={'panels.assignment.remakeTask'}
            handlePrimaryButtonClick={repeatTask => this.onSubmitButtonClick(repeatTask)}
            handleRemakeButtonClick={repeatTask => this.onSubmitButtonClick(repeatTask)}
            disableRemakeButton={disableRemakeButton}
          />
        )}
      </div>
    );
  }
}

InstructorTaskPanel.propTypes = {
  task: PropTypes.any,
  filteredTasks: PropTypes.array,
  taskActions: PropTypes.any,
  bookActions: PropTypes.any,
  classroom: PropTypes.any,
  user: PropTypes.any,
  role: PropTypes.string,
  responseFile: PropTypes.any,
  drawerActions: PropTypes.any,
  assignmentsDrawerActions: PropTypes.any,
  evaluatedStudent: PropTypes.any,
  avatarsImages: PropTypes.any,
  emojis: PropTypes.any,
  evaluateFreeTask: PropTypes.bool,
  customer: PropTypes.any
};

function mapStateToProps(state) {
  const classroom = state.classrooms.activeClassrooms.find(c => c.id === state.task.selectedTask.parentSection);
  return {
    i18n: state.i18n,
    task: state.task.selectedTask,
    filteredTasks: state.task.filteredTasks.tasks,
    colors: state.theme.colors,
    emojis: state.theme.images.emojis,
    responseFile: state.assignmentsDrawerActions.responseFile,
    defaultIcon: state.theme.images.placeholders.attachmentIcon,
    user: state.account.user,
    role: classroom && classroom.role,
    classroom: classroom && classroom,
    participants: state.classrooms.selectedClassroom.participants,
    avatarsImages: state.theme.images.avatars,
    evaluatedStudent: state.assignmentsDrawerActions.evaluatedStudent,
    customer: state.school.school.customer
  };
}

function mapDispatchToProps(dispatch) {
  return {
    taskActions: bindActionCreators(taskActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstructorTaskPanel);
